import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { validateEntitySchema } from './validate-entity-schema.js'
import { validateFormSchema } from './validate-form-schema.js'
import { validateSingleSchema } from './validate-single-schema.js'

export function validateLoadedSchema(loaded: LoadedSchema): string[] {
  if (loaded.type === 'entity') {
    return validateEntitySchema(loaded.schema)
  }
  if (loaded.type === 'single') {
    return validateSingleSchema(loaded.schema)
  }
  return validateFormSchema(loaded.schema)
}
